import "./dashboard-sections.css";

const PerfRow = ({ label, value, valueColor }) => (
  <div className="bd-perf-row">
    <span className="bd-perf-label">{label}</span>
    <span className="bd-perf-value" style={valueColor ? { color: valueColor } : {}}>{value ?? "—"}</span>
  </div>
);

const YieldEfficiency = ({ data = {}, isLoading = false }) => (
  <div className="bd-right-col cmn_card">
    <div className="bd-perf-header">PROCESSING PERFORMANCE</div>
    <div className="bd-perf-body">
      <PerfRow
        label="KG Prime %"
        value={`${data?.kg_prime_prcnt ?? "0"}%`}
        valueColor="#25aa91"
      />
      <PerfRow label="KG Prime"       value={`${data?.kg_prime_total?.toLocaleString() ?? "0"} kg`} />
      <PerfRow label="KG Prime Rework" value={`${data?.kg_prime_rework?.toLocaleString() ?? "0"} kg`} />
      <PerfRow label="KG/Case Ratio"  value={data?.kg_per_case ?? "0"} />
      <PerfRow label="Cases/Cart" value={data?.cases_per_cart ?? "0"} />
      <PerfRow label="Total Peelers"  value={data?.total_number_of_peelers ?? "0"} />
    </div>
  </div>
);

export default YieldEfficiency;
